// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".totalNumber[data-v-cdd1774c] {\n  color: #a8aeb8;\n  font-weight: 400;\n  font-size: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
